<template>
  <div
    class="tooltip-container"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <div v-if="visible" :class="['tooltip-box', position]" class="text-center" ref="tooltipBox">
      <slot name="text"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    position: {
      type: String,
      default: "top",
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showTooltip() {
      this.visible = true;
      this.$nextTick(this.adjustPosition);
    },
    hideTooltip() {
      this.visible = false;
    },
    adjustPosition() {
      const tooltipBox = this.$refs.tooltipBox;
      const { top, bottom, left, right } = tooltipBox.getBoundingClientRect();
      const { innerWidth, innerHeight } = window;

      if (top < 0) {
        this.position = "bottom";
      } else if (bottom > innerHeight) {
        this.position = "top";
      } else if (left < 0) {
        this.position = "right";
      } else if (right > innerWidth) {
        this.position = "left";
      }
    },
  },
};
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}
.tooltip-box {
  position: absolute;
  background-color: #333;
  color: #fff;
  padding: 8px 12px;
  border-radius: 8px;
  white-space: nowrap;
  z-index: 2147483647 !important;
}
.tooltip-box.top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
}
.tooltip-box.bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5px;
}
.tooltip-box.left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 5px;
}
.tooltip-box.right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 5px;
}
</style>
